import React, { useState } from "react";
// import LifeHistoryGoals from "../../assets/images/icons/user-profile/LifeHistoryGoals.svg";
import eMARSettings from "../../assets/images/icons/eMARSettings.svg";
import DeviceManagement from "../../assets/images/icons/DeviceManagement.svg";
import AccessSettings from "../../assets/images/icons/AccessSettings.svg";
import CommunicationSettings from "../../assets/images/icons/CommunicationSettings.svg";
import OneTimeCodeSettingsImage from "../../assets/images/icons/OneTimeCodeSettings.svg";
import passwordIcon from "../../assets/images/icons/passwordIcon.svg";
import { useNavigate } from "react-router-dom";
import PermissionWrapper from "../../permission_advance/PermissionWrapper";
import ServiceUsersOptionsBlocks from "../../components/user-detail/ServiceUsersOptionsBlocks";
import Layout from "../../components/layouts/Layout";
function PermissionsBlock() {
    const navigate = useNavigate();
    const handleRowClickPermissionsBlock = (url) => {
        navigate(url);
    };

    const [showOneTimeSettings, setShowOneTimeSettings] = useState(false);
    const subModalOneTimeSettings = () => {
        setShowOneTimeSettings(!showOneTimeSettings);
    };

    const [showPasswordChange, setPasswordChange] = useState(false);
    const subModalPasswordChangeModal = () => {
        setPasswordChange(!showPasswordChange);
    };

    const [showCommunicationSettings, setCommunicationSettings] = useState(false);
    const subModalCommunicationSettings = () => {
        setCommunicationSettings(!showCommunicationSettings);
    };
    return (
        <>
            <Layout pageTitleText="Permissions Blocks">
                <div className="scheduleBlocks careplanOptions">
                    <div className="row">
                        <PermissionWrapper title="Super Admin" action="update">
                            <div className="col-md-3 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={passwordIcon}
                                    heading={"Role Based Permissions"}
                                    linkedComponent={() => { handleRowClickPermissionsBlock("/role-based-permissions") }}
                                />
                            </div>
                        </PermissionWrapper>
                        <PermissionWrapper title="Super Admin" action="update">
                            <div className="col-md-3 col-sm-6">
                                <ServiceUsersOptionsBlocks
                                    blockIcon={passwordIcon}
                                    heading={"User Based Permissions"}
                                    linkedComponent={() => {
                                        subModalOneTimeSettings();
                                    }}
                                />
                            </div>
                        </PermissionWrapper>
                    </div>
                </div>
            </Layout>

        </>
    )
}

export default PermissionsBlock